import { render, staticRenderFns } from "./authGroup.vue?vue&type=template&id=2e25d55c&scoped=true&"
import script from "./authGroup.vue?vue&type=script&lang=js&"
export * from "./authGroup.vue?vue&type=script&lang=js&"
import style0 from "./authGroup.vue?vue&type=style&index=0&id=2e25d55c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e25d55c",
  null
  
)

export default component.exports